<template>
	<div class="MAM_queryList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.channel_mer_no" placeholder="请输入商户编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column  min-width="150" header-align="center" align="center" prop="channel_mer_no" label="商户编码"></el-table-column>
                <el-table-column  min-width="150" header-align="center" align="center" prop="ch_merchant_name" label="商户名称"></el-table-column>
                <el-table-column  min-width="150" header-align="center" align="center" prop="mer_phone" label="商户手机号"></el-table-column>
                <el-table-column min-width="150"   header-align="center" align="center" prop="withdraw_money" label="提现金额(元)">
                </el-table-column>
				<el-table-column  min-width="180"  header-align="center" align="center" prop="settle_card_no" label="结算卡信息"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="bank_name" label="开户总行"></el-table-column>
				<el-table-column min-width="200"   header-align="center" align="center" prop="bank_branch" label="支行信息"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="create_time" label="提现时间"></el-table-column>
                <el-table-column  min-width="180" header-align="center" align="center" prop="withdraw_status_text" label="提现状态"></el-table-column>
                <el-table-column  min-width="180" header-align="center" align="center" prop="remark" label="提现备注"></el-table-column>
                <el-table-column min-width="100"  header-align="center" align="center" fixed="right" label="操作"  >
                	<template  slot-scope="scope">
                		<el-button @click="updateClick(scope.row)" type="text" size="small">更新状态</el-button>
                	</template>
                	
                </el-table-column>
			</el-table>
            <!-- 分页部分 -->
            <paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
            	@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
	</div>
</template>

<script>
    import paginations from '../../components/pagination/paginations';
	export default {
		name: "ysBalanceApplyRecordList",
		data() {
			return {
				queryForm: {
					channel_mer_no:''
				},
				stockTable: { //列表
					list: [],
				},
				loading: false,
				downLoading: false, //导出loading
                page: {
                	currentPage: 1, //当前页码
                	pageSize: 10, //条数
                	total: 0 //总数
                },
			}
		},
        components: {
        	paginations,
        },
        mounted() {
        	this.getData({
        		page: this.page.currentPage,
        		limit: this.page.pageSize
        	})
        },
		methods: {
            updateClick(item){
                let params = {
                	id:item.id
                }
                this.loading = true;
                this.$api.post("mc_with_draw/upMcWithDrawStatus", params, res => {
                	if (res.code == 0) {
                		this.$message({
                		    message: '出款成功!',
                			type:'success'
                		});
                	}else {
                		this.$message({
                		    message: res.msg
                		});
                	}
                    this.queryForm.page = this.page.currentPage;
                    this.queryForm.limit = this.page.pageSize;
                    this.getData(this.queryForm);
                })
            },
			onSearch(queryForm) {
                this.page.currentPage = 1;
                queryForm.page = this.page.currentPage;
                queryForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(queryForm);
			},
            //分页
            getCurrent(page) {
            	// 获取当前页修改的值
            	this.page.currentPage = page;
            	this.loading = true;
            	this.queryForm.page = page;
            	this.queryForm.limit = this.page.pageSize;
            	this.getData(this.queryForm);
            },
            getPageSize(limit) {
            	this.page.currentPage = 1;
            	// 获取条数发生改变的值
            	this.page.pageSize = limit;
            	this.loading = true;
            	this.queryForm.page = this.page.currentPage;
            	this.queryForm.limit = limit;
            	this.getData(this.queryForm);
            },
			getData(params) {
				this.$api.post("mc_with_draw/selMcWithDrawList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.stockTable.list = data.list;
                        this.page.total = data.count; //总数
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.dialogDes {
		height: 30px;
		line-height: 30px;
	}
</style>